import React from "react";
import { Box, IconButton, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { radii } from "../../../../theme/shape";

const MessageMediaActions = ({
  onPickImage,
  onPickPdf,
  onReplaceMedia,
  onRemoveMedia,
  messageId,
  mediaKind,
  hasMedia = false,
  floating = false,
  readOnly = false,
}) => {
  const theme = useTheme();
  const mediaOverlayColor = alpha(theme.palette.common.black, 0.68);
  const mediaOverlayHoverColor = alpha(theme.palette.common.black, 0.78);

  const handlePickImage = () => {
    if (readOnly || typeof onPickImage !== "function") return;
    onPickImage(messageId);
  };

  const handlePickPdf = () => {
    if (readOnly || typeof onPickPdf !== "function") return;
    onPickPdf(messageId);
  };

  const handleReplace = () => {
    if (readOnly || typeof onReplaceMedia !== "function") return;
    onReplaceMedia(messageId, mediaKind);
  };

  const handleRemove = () => {
    if (readOnly || typeof onRemoveMedia !== "function") return;
    onRemoveMedia(messageId);
  };

  if (hasMedia) {
    return (
      <Box
        sx={{
          ...(floating
            ? {
                position: "absolute",
                top: 6,
                right: 6,
                zIndex: 2,
              }
            : {
                mb: 0.75,
              }),
          display: "flex",
          justifyContent: "flex-end",
          gap: 0.5,
        }}
      >
        <IconButton
          size="small"
          onClick={handleReplace}
          sx={{
            width: 40,
            height: 40,
            borderRadius: radii.circle,
            backgroundColor: mediaOverlayColor,
            color: "common.white",
            "&:hover": { backgroundColor: mediaOverlayHoverColor },
          }}
        >
          <AttachFileOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>

        <IconButton
          size="small"
          onClick={handleRemove}
          sx={{
            width: 40,
            height: 40,
            borderRadius: radii.circle,
            backgroundColor: mediaOverlayColor,
            color: "common.white",
            "&:hover": { backgroundColor: mediaOverlayHoverColor },
          }}
        >
          <DeleteOutlineOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mb: 1,
        p: 0.75,
        borderRadius: radii.xl,
        backgroundColor: "surface.subtle",
        display: "flex",
        justifyContent: "center",
        gap: 1.1,
      }}
    >
      <IconButton
        size="small"
        onClick={handlePickImage}
        sx={{
          width: 46,
          height: 46,
          borderRadius: radii.circle,
          backgroundColor: "surface.muted",
          "&:hover": { backgroundColor: "action.selected" },
        }}
      >
        <PhotoCameraOutlinedIcon sx={{ fontSize: 21, color: "text.secondary" }} />
      </IconButton>

      <IconButton
        size="small"
        onClick={handlePickPdf}
        sx={{
          width: 46,
          height: 46,
          borderRadius: radii.circle,
          backgroundColor: "surface.muted",
          "&:hover": { backgroundColor: "action.selected" },
        }}
      >
        <PictureAsPdfOutlinedIcon sx={{ fontSize: 21, color: "text.secondary" }} />
      </IconButton>
    </Box>
  );
};

export default MessageMediaActions;
